<template>
  <div class="road-plan-container">
    <PlanItem
      v-for="(item, index) in items"
      :key="index + item.key"
      v-bind="{ item }"
    />
  </div>
</template>

<script>
import PlanItem from './PlanItem';
import Moment from 'moment';
import { mapGetters } from 'vuex';
import PublicPackageApi from '@/api/public';
const NO_DATA = 'No data';
export default {
  components: {
    PlanItem,
  },
  data() {
    return {
      initialized: false,

      items: [
        {
          key: 'startingPoint',
          value: null,
          label: 'Starting point',
          line: { class: 'notBlack', type: 'arrow' },
          children: [
            {
              key: 'left',
              value: null,
              label: 'left',
            },
            {
              key: 'travelling',
              value: null,
              label: 'Travelling',
            },
          ],
        },
        {
          key: 'destination',
          value: null,
          label: 'Destination',
          line: { class: 'accentGreen', type: 'circle' },
          children: [
            {
              key: 'planned_arrival',
              value: NO_DATA,
              label: 'Planned arrival',
            },
            {
              key: 'expected_arrival',
              value: NO_DATA,
              label: 'Expected arrival',
            },
          ],
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      sensorUid: 'shipments/sensorUid',
      track: 'packageDetails/track/list',
    }),

    dataReady() {
      return this.track.length > 0;
    },
  },

  watch: {
    dataReady() {
      this.$emit('loaded');
      this.$nextTick(() => {
        this.initShipmentPlan();
      });
    },
  },

  mounted() {
    this.$emit('loaded');
    this.$nextTick(() => {
      this.initShipmentPlan();
    });
  },


  methods: {
    async initShipmentPlan() {
      if (!this.track || !this.track[0] || this.initialized) {
        return;
      }

      ///////////////////////////////////////////////////////
      // startingPoint - инфа об отправке и времени в пути
      ///////////////////////////////////////////////////////

      const firstTx = this.track[0];

      // const { length } = this.track[0].samples;
      // const lastTx = this.track[0].samples[length - 1];

      const { location: startLocation } = firstTx._source;

      let startingPointItem = this.getPlanItem('startingPoint');

      startingPointItem.value = startLocation.locality
        ? startLocation.locality
        : startLocation.addr
          ? startLocation.addr
          : NO_DATA;

      const startTime = Moment(firstTx._source.timestamp);

      // left - время когда сенсор стартанул
      startingPointItem.children[0].value = startTime.format('MMM DD, HH:mm');

      // travelling - сколько сенсор находится в пути. Считаем разницу текущего времени и времени старта.
      const diff = Moment() - startTime;
      startingPointItem.children[1].value = Moment.duration(diff).humanize();

      ///////////////////////////////////////////////////////
      // Destination - инфа о месте назначения
      ///////////////////////////////////////////////////////

      PublicPackageApi.getShipment({ hash: this.sensorUid }).then(
        (response) => {
          let destinationItem = this.getPlanItem('destination');
          const { destination } = response.data[0];
          try {
            destinationItem.value = JSON.parse(destination).name;
          } catch (error) {
            console.log(error);
            destinationItem.value = NO_DATA;
          }
        }
      );
    },

    getPlanItem(key) {
      return this.items.find((item) => item.key === key);
    },
  },
};
</script>


<style scoped lang="scss">
.road-plan-container {
  overflow-y: scroll;
}
</style>